<client-reach-menu activeSection="1">
	<ng-container
		*clientReachMenuSection="'1'; desktopType: 'POPUP'; lightBg: true; alwaysUseDesktop: true"
	>
		<warning-template class="pos-rel fl fl-adaptable w-100 fl-dir-c">
			<ng-content select="[image]" ngProjectAs="[image]"></ng-content>
			<ng-content select="[title]" ngProjectAs="[title]"></ng-content>
			<ng-content></ng-content>
			<div class="fl fl-dir-r fl-gap-1 w-100" ngProjectAs="[options]">
				<ng-content select="[options]">
					@if ($showCancel()) {
						<button class="w-100" buttonOutlined (click)="onCancel()">
							{{ $cancelText() }}
						</button>
					}
					<button
						class="w-100"
						buttonFilled
						[flavor]="$mappedConfirmVariant()"
						(click)="onConfirm()"
					>
						{{ $confirmText() }}
					</button>
				</ng-content>
			</div>
		</warning-template>
	</ng-container>
</client-reach-menu>
